/**
 * `planning.*` wire contract — a style's production capacity plan (unit /
 * supervisor / dates / daily target). Behind `entitledProcedureFor("garment.production")`.
 */
import { z } from "zod";
import { uuid, isoDate } from "../_common.js";

export const planView = z.object({
  styleId: uuid,
  unit: z.string().nullable(),
  supervisor: z.string().nullable(),
  plannedStartDate: isoDate.nullable(),
  targetDate: isoDate.nullable(),
  dailyTargetPcs: z.number().int().nullable(),
  notes: z.string().nullable(),
});

export const getInput = z.object({ styleId: uuid });
export const getOutput = planView.nullable();

export const upsertInput = z.object({
  styleId: uuid,
  unit: z.string().trim().max(64).nullable().optional(),
  supervisor: z.string().trim().max(64).nullable().optional(),
  plannedStartDate: isoDate.nullable().optional(),
  targetDate: isoDate.nullable().optional(),
  dailyTargetPcs: z.number().int().min(0).max(1_000_000).nullable().optional(),
  notes: z.string().trim().max(2000).nullable().optional(),
});
export const upsertOutput = planView;

export type PlanViewWire = z.infer<typeof planView>;
